<template>
  <v-bottom-sheet v-model="sheet" persistent scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-card class="mt-5 text-left">
        <v-card-text>
          <v-row align="center" no-gutters>
            <v-col cols="auto">
              <v-avatar size="60" v-if="instructor.attributes.profilePicture">
                <img alt="Avatar" :src="instructor.attributes.profilePicture" />
              </v-avatar>
              <v-avatar size="60" v-else>
                <img
                  alt="Avatar"
                  src="https://thedriverx.com/assets/images/user.png"
                />
              </v-avatar>
            </v-col>
            <v-col class="mx-2">
              <h2 class="black--text font-weight-medium pl-1">
                {{
                  `${instructor.attributes.firstName} ${instructor.attributes.lastName}`
                }}
              </h2>
              <p class="mb-0 pl-1" v-if="instructor.attributes.schoolName">
                {{ `${instructor.attributes.schoolName}` }},
                {{ `${instructor.attributes.instructorCities.join(', ')}` }}
              </p>
              <p class="mb-0 pl-1" v-else>
                {{ `${instructor.attributes.instructorCities.join(', ')}` }}
              </p>
              <v-rating
                :value="instructor.attributes.avgRatings"
                color="warning"
                background-color="warning"
                half-increments
                dense
                size="20"
                readonly
              />
            </v-col>
            <v-col cols="auto">
              <h2>
                ${{ `${instructor.attributes[option || 'booking_lesson'] || 0}`
                }}<template v-if="option === 'booking_lesson'" || !option
                  >/hr</template
                >
              </h2>
            </v-col>
          </v-row>
          <v-row v-if="showModal">
            <v-col cols="auto" style="margin-left: 4.25rem">
              <v-btn
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
                :disabled="!cardAdded"
              >
                Book Now
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <v-card>
      <v-toolbar flat dark color="primary" class="mb-8">
        <v-spacer />
        <v-btn icon dark @click="sheet = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="max-height: 100vh">
        <h2 v-if="instructor.get('schoolName')" class="grey--text">
          {{ instructor.get('schoolName') }}
        </h2>
        <h3 class="mb-1">
          <template v-if="option === 'booking_lesson'">
            Booking individual driving lesson
          </template>
          <template v-if="option === 'roadtest_rent_car'">
            Rent instructor's car for roadtest
          </template>
          <template v-if="option === 'rentcar_n_lesson'">
            Roadtest package (1hr lesson + car rental)
          </template>
          (${{ `${instructor.attributes[option]}`
          }}<span v-if="option === 'booking_lesson'">/hr</span>)
        </h3>
        <p v-if="false">Nothing to show</p>
        <v-row>
          <v-col class="py-0">
            <datetime-picker
              v-model="datetime1"
              @date="selectedDate = $event"
              @hour="selectedHour = $event"
              label="Select Datetime"
              :timePickerProps="{
                allowedHours,
                allowedMinutes,
                ampmInTitle: true,
              }"
              :datePickerProps="{
                allowedDates,
              }"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="py-0"
            v-if="sheet && option === 'booking_lesson'"
          >
            <datetime-picker
              label="Select Datetime"
              v-model="datetime2"
              @date="selectedDate = $event"
              @hour="selectedHour = $event"
              :timePickerProps="{
                allowedHours,
                allowedMinutes,
                ampmInTitle: true,
              }"
              :datePickerProps="{
                allowedDates,
              }"
            />
          </v-col>
          <v-col
            cols="12"
            sm="4"
            class="py-0"
            v-if="sheet && option === 'booking_lesson'"
          >
            <datetime-picker
              label="Select Datetime"
              v-model="datetime3"
              @date="selectedDate = $event"
              @hour="selectedHour = $event"
              :timePickerProps="{
                allowedHours,
                allowedMinutes,
                ampmInTitle: true,
              }"
              :datePickerProps="{
                allowedDates,
              }"
            />
          </v-col>
        </v-row>

        <v-textarea
          auto-grow
          rows="4"
          label="Note for Instructor"
          v-model="note"
        />

        <v-checkbox v-if="option === 'booking_lesson'" v-model="parking">
          <template v-slot:label>
            <div class="text-left">
              <strong>Parking</strong>: Parellel parking, reverse parking,
              uphill parking, downhill parking, front parking, illegal parkings,
              angle parkings.
            </div>
          </template>
        </v-checkbox>
        <v-checkbox v-if="option === 'booking_lesson'" v-model="highwayDriving">
          <template v-slot:label>
            <div class="text-left">
              <strong>Highway driving</strong>: Entering a freeway, driving
              along a freeway, changing lanes, HOV lane, leaving a freeway.
            </div>
          </template>
        </v-checkbox>
        <v-checkbox
          v-if="option === 'booking_lesson'"
          v-model="innerCityDrivingTurns"
        >
          <template v-slot:label>
            <div class="text-left">
              <strong>innerCityDrivingTurns</strong>: 2pt turn, 3pt turn, Uturn,
              right hand turn, left hand turn, crossing an intersection,
              changing lanes, checking blindspots, stop signs and other road
              signs, round abouts, driving in school zone.
            </div>
          </template>
        </v-checkbox>

        <v-radio-group v-model="mockRoadTest">
          <v-radio label="Mock road test G2" value="mockRoadTestG2">
            <template v-slot:label>
              <div class="text-left">
                Overview of all the basic driving skills, behaviors and
                knowledge needed to pass the G2 driving exam. Does not include
                highway driving.
              </div>
            </template>
          </v-radio>

          <v-radio label="Mock road test G" value="mockRoadTestG">
            <template v-slot:label>
              <div class="text-left">
                Overview of all the basic driving skills, behaviors and
                knowledge needed to pass the G driving exam. Includes an
                overview of highway driving.
              </div>
            </template>
          </v-radio>
        </v-radio-group>

        <v-select
          :items="packages"
          label="Select Option"
          :value="option"
          @input="$emit('update:option', $event)"
        />
        <v-row>
          <v-col>
            <v-btn @click="sheet = false" block> Close </v-btn>
          </v-col>
          <v-col>
            <v-btn
              @click="submit"
              color="primary"
              block
              :loading="isLoading"
              :disabled="!selectedDateTimes.length"
            >
              Request Appointment
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import Parse from 'parse'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    schoolPackageId: String,
    instructor: {
      type: Object,
      required: true
    },
    option: {
      type: String,
      required: true
    },
    showModal: {
      type: Boolean,
      default: true
    },
    cardAdded: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isLoading: false,
      tab: null,
      sheet: false,
      amount: this.instructor.attributes.booking_lesson,
      selectedDate: null,
      selectedHour: null,
      datetime1: null,
      datetime2: null,
      datetime3: null,
      note: '',
      approvedDateTimes: [],
      selectedDateTimes: [],
      parking: false,
      highwayDriving: false,
      innerCityDrivingTurns: false,
      mockRoadTest: null,
      packages: [
        {
          value: 'booking_lesson',
          text: 'Booking Lesson'
        },
        {
          value: 'roadtest_rent_car',
          text: 'Roadtest'
        },
        {
          value: 'rentcar_n_lesson',
          text: 'Roadtest + Rent car'
        }
      ],
      today: this.$moment(new Date())
    }
  },
  computed: mapGetters([
    'user',
    'studentAppointment',
    'instructorAppointments',
    'pushNotification'
  ]),
  watch: {
    datetime1 (v) {
      if (v) {
        this.selectedDateTimes.push({
          start: this.$moment(v.date + ' ' + v.time).format(
            'YYYY/MM/DD HH:mm'
          )
        })
      }
    },
    datetime2 (v) {
      if (v) {
        this.selectedDateTimes.push({
          start: this.$moment(v.date + ' ' + v.time).format(
            'YYYY/MM/DD HH:mm'
          )
        })
      }
    },
    datetime3 (v) {
      if (v) {
        this.selectedDateTimes.push({
          start: this.$moment(v.date + ' ' + v.time).format(
            'YYYY/MM/DD HH:mm'
          )
        })
      }
    },
    instructorAppointments (bookings) {
      this.approvedDateTimes = bookings
        .filter((appointment) => appointment.get('status') === 'Approved')
        .map((booking) => ({
          start: booking.get('start'),
          end: booking.get('end')
        }))
    }
  },
  methods: {
    ...mapActions([
      'toggleDialog',
      'saveStudentAppointment',
      'updateUser',
      'getInstructorAppointments',
      'sendPushNotification'
    ]),
    allowedDates (val) {
      return (
        this.$moment(val).diff(this.today) > 0 ||
          this.$moment(val).isSame(new Date(), 'day')
      )
    },
    allowedHours (currentHour) {
      let allowed = true
      this.approvedDateTimes.forEach((dateTime) => {
        const isSame = this.$moment(dateTime.start).isSame(
          this.selectedDate,
          'day'
        )

        if (isSame) {
          const startHour = dateTime.start.getHours()
          const startMinute = dateTime.start.getMinutes()
          const endHour = dateTime.end.getHours()
          const endMinute = dateTime.end.getMinutes()
          const startingBlockedHour =
              startMinute < 30 ? startHour - 1 : startHour
          const endingBlockedHour = endMinute >= 30 ? endHour : endHour - 1
          allowed = !(
            currentHour >= startingBlockedHour &&
              currentHour <= endingBlockedHour
          )
        }
      })

      return allowed
    },
    allowedMinutes (currentMinute) {
      let allowed = true
      this.approvedDateTimes.forEach((dateTime) => {
        const isSame = this.$moment(dateTime.start).isSame(
          this.selectedDate,
          'day'
        )
        const startHour = dateTime.start.getHours()
        const startMinute = dateTime.start.getMinutes()
        const endHour = dateTime.end.getHours()
        const endMinute = dateTime.end.getMinutes()
        const startingBlockedHour =
            startMinute < 30 ? startHour - 1 : startHour
        const endingBlockedHour = endMinute >= 30 ? endHour : endHour - 1
        if (isSame) {
          if (this.selectedHour === startingBlockedHour - 1) {
            allowed = currentMinute < 60 - startMinute
          }
          if (this.selectedHour === endingBlockedHour + 1) {
            allowed = currentMinute > 60 - endMinute
          }
        }
      })
      return allowed
    },
    async submit () {
      this.isLoading = true
      /** Send datetime options, instructor id, instructor package id, student id, package name */
      const addressTwo = this.user.get('addressTwo')
      const addressOne = this.user.get('addressOne')
      const city = this.user.get('city')
      const province = this.user.get('province')
      const postalCode = this.user.get('postalCode')

      let studentAddress = ''
      if (addressTwo) {
        studentAddress += addressTwo + ' '
      }
      if (addressOne) {
        studentAddress += addressOne + ' '
      }
      if (city) {
        studentAddress += city + ' '
      }
      if (province) {
        studentAddress += province + ' '
      }
      if (postalCode) {
        studentAddress += postalCode
      }
      await this.saveStudentAppointment({
        instructorId: this.instructor.id,
        studentId: this.user.id,
        parking: this.parking,
        highwayDriving: this.highwayDriving,
        innerCityDrivingTurns: this.innerCityDrivingTurns,
        roadtestOptions: this.mockRoadTest,
        notes: this.note,
        studentAddress: studentAddress,
        selectedDateTimes:
            this.option === 'booking_lesson'
              ? this.selectedDateTimes
              : this.selectedDateTimes[0],
        package: this.option,
        instructorPackageId: this.instructor.attributes.instructorPackageId,
        schoolPackageId: this.schoolPackageId
      })

      if (this.studentAppointment) {
        // Send push + email to the instructor. Push is off for now as we are sending SMS in bellow
        // if (typeof this.instructor.get('deviceId') !== 'undefined') {
        //   await this.sendPushNotification({
        //     player_id: this.instructor.get('deviceId'),
        //     message: 'New booking request. ' + this.note,
        //     type: 'appmnt',
        //     senderId: this.user.id,
        //     name: this.user.get('firstName') + ' ' + this.user.get('lastName')
        //   })
        // }
        const option = this.$moment(this.selectedDateTimes[0].start).format(
          'LLL'
        )
        const smsMessage =
            this.user.get('firstName') +
            ' ' +
            this.user.get('lastName') +
            ' has booked an appointment on ' +
            option +
            ' Please log in to the app or click on this link to view details https://thedriverx.com/applink.php?appId=' +
            this.studentAppointment.id
        const smsData = {
          message: smsMessage,
          to: this.instructor.attributes.phone
        }
        /** call the cloud function */
        Parse.Cloud.run('sendAppointmentSMS', smsData).then((result) => {
          console.log('Text successful' + JSON.stringify(result))
        })

        /** Send email notification */
        const data = {
          email: this.instructor.attributes.customEmail,
          requesterName:
              this.user.get('firstName') + ' ' + this.user.get('lastName')
        }
        /** call the cloud fundtion */
        Parse.Cloud.run('newAppointmentEmail', data).then(() => {
          console.log('Email successful')
        })

        /** Send ADMIN the same message but without URI */
        const adminNotiMessage =
            this.user.get('firstName') +
            ' ' +
            this.user.get('lastName') +
            ' has booked an appointment on ' +
            option +
            ' for instructor ' +
            this.instructor.attributes.firstName +
            ' ' +
            this.instructor.attributes.lastName +
            ' in the city of ' +
            this.user.get('city') +
            ', ' +
            this.user.get('province')
        const adminSmsData = {
          message: adminNotiMessage,
          to: '+16474592887'
        }
        console.log(adminSmsData)
        /** call the cloud fundtion */
        Parse.Cloud.run('sendAppointmentSMS', adminSmsData).then(() => {
          console.log('Text successful')
        })

        /** Let's flag that this student went through let's get started */
        this.updateUser({
          getStartedDone: true
        })

        this.toggleDialog({
          status: true,
          title: 'Success',
          message: 'Thank you! Your appointment request has been sent.'
        })
      } else {
        this.toggleDialog({
          status: true,
          title: 'Error',
          message: 'Something went wrong, please try again'
        })
      }

      this.emptyFields()
      this.isLoading = false
      this.sheet = false
    },
    emptyFields () {
      this.datetime1 = null
      this.datetime2 = null
      this.datetime3 = null
      this.note = ''
      this.approvedDateTimes.length = 0
      this.selectedDateTimes.length = 0
      this.parking = false
      this.highwayDriving = false
      this.innerCityDrivingTurns = false
      this.mockRoadTest = null
    }
  },
  created () {
    const date = new Date()
    const y = date.getFullYear()
    const m = date.getMonth()
    this.getInstructorAppointments({
      start: new Date(y, m, 1),
      end: new Date(y, m + 3, 0),
      instructorId: this.instructor.id
    })
  }
}
</script>
